import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LocalGasStationIcon(props: IconProps) {
    return <Icon {...props} iconKey={"local_gas_station"}/>
}
